import React, { useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CardHeader,
} from "@material-ui/core/";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from 'moment';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Icon from "@material-ui/core/Icon";
import Select from '@material-ui/core/Select';
import Colors from "../../../Global/colors"
import MenuItem from "@material-ui/core/MenuItem";  
import FormControl from '@material-ui/core/FormControl';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Tooltip from "@material-ui/core/Tooltip";
import {useTranslation} from 'react-i18next';
import "./input.css";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "transparent",
    padding: "0px 5px 5px 5px",
    margin: 5,
  },
  typography: {
    // padding: theme.spacing(0.6),
    // textAlign: 'center',
    // fontSize: 15,
    fontWeight: "bold",
    color: theme.palette.text.secondary,
  },
  textField: {
    marginLeft: theme.spacing(0),
    // marginRight: theme.spacing(1),
    // width: 150,
    // padding: 0
  },
  input: {
    padding: 0,
  },
}));

export const NewSearchBar = ({
  value,
  handleSideBarChange,
  handleSideBarSubmitProgress,
  templates,
  companies,
  inspections,
  sites,
  handleSideBarSubmitProgressPrevious,
  packageDetails,
  btnLoader,
  setBtnLoader,
  closeModal
}) => {
  const {t} = useTranslation();
  const language = useSelector(state => state.languageReducer.language);
  const startDate = moment(value.end).subtract(3,"months");
  const endDate = moment(value.from).add(3,"months");

  const startDatePrev = moment(value.previous_end).subtract(3,"months");
  const endDatePrev = moment(value.previous_from).add(3,"months");

  const [previousStartDate, setPreviousStartDate] = useState();
  const [previousEndDate, setPreviousEndDate] = useState();
  const [currentStartDate, setCurrentStartDate] = useState();
  const [currentEndDate, setCurrentEndDate] = useState();
  // const [template, setTemplate] = useState('');
  // const [inspection, setInspection] = useState('');
  // const [site, setSite] = useState('');
  const sampleData = [
    { title: "Shawshank", year: 1994 },
    { title: "Godfather", year: 1972 },
    { title: "GodfatherII", year: 1974 },
    { title: "Dark Knight", year: 2008 },
  ];
  const handlePreviousStartDateChange = (date) => {
    setPreviousStartDate(date);
  };
  const handlePreviousEndDateChange = (date) => {
    setPreviousEndDate(date);
  };
  const handleCurrentStartDateChange = (date) => {
    setCurrentStartDate(date);
  };
  const handleCurrentEndDateChange = (date) => {
    setCurrentEndDate(date);
  };
  // const handleTemplateChange = (event) => {
  //     setTemplate(event.target.value);
  // };
  // const handleInspectionChange = (event) => {
  //     setInspection(event.target.value);
  // };
  // const handleSiteChange = (event) => {
  //     setSite(event.target.value);
  // };
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div style={{display:'flex', justifyContent:'center', alignItems:'center',marginBottom:10}}>
      <p className="filterHeading" style={{ color: "#306086", justifyContent: "center", display: "flex", fontSize: 20, fontWeight:'bold',marginTop:0,marginBottom:0, }}>
        {t("Search & Filters")}
      </p>
      &nbsp;
      <Tooltip title={t("Represents the comparison of current and previous inspections by specifying the date range, template format, inspection type and sites being inspected to review the performance")}>
                        <HelpOutlineIcon style={{color:Colors.globalColor8, cursor:'pointer'}} />
                    </Tooltip>

                    </div>
      
      <Grid spacing={0} alignItems="center "justify="center" >
       
        <Grid //container={true} item xs={12} lg={10} md={8} sm={9} spacing={1}
         style={{display:'flex',justifyContent: "center",flexDirection:'column'}}
        >
          <Grid item xs={12}  md={8} sm={12} style={{alignSelf:'center',marginBottom:10}}>
          <div style={{flexDirection:'row',display:'flex',justifyContent:'space-between'}}>
            <div className={classes.typography} style={{color:'#19123e'}}>
            <p className="filterHeading" style={{ color: "#306086", justifyContent: (language == "ar" ? "right" :"left"), display: "flex", fontSize: 14, fontWeight:'bold',marginTop:0,marginBottom:0 }}>
        {t("From")}
      </p>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                classes={{ input: classes.input }}
              >
                <KeyboardDatePicker
                  disableToolbar
                  //variant="inline"
                  format="MM/dd/yyyy"
                  // margin="normal"
                  id="date-picker-inline"
                  //   disablePast={true}
                  value={value.from}
                  disableFuture 
                  minDate={startDate}
                  onChange={(e) =>
                    handleSideBarChange({ target: { name: "from", value: e } })
                  }
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  InputProps={{
                    disableUnderline: true,
                   }}
                  keyboardIcon={<Icon style={{color:'#0b79b6',fontSize:25,alignSelf: "center",height:35}}>date_range</Icon>}
                  fullWidth
                  // minDate={
                  //   packageDetails?.data?.id !==
                  //   "09b7b809-3f45-4439-9836-ba91b160174d"
                  //     ? new Date(
                  //         new Date(
                  //           new Date().getFullYear(),
                  //           new Date().getMonth(),
                  //           1
                  //         )
                  //       )
                  //     : undefined
                  // }
                  className={classes.textField}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div className={classes.typography} style={{color:'#19123e'}}>
            <p className="filterHeading" style={{ color: "#306086", justifyContent: (language == "ar" ? "right" :"left"), display: "flex", fontSize: 14, fontWeight:'bold',marginTop:0,marginBottom:0 }}>
        {t("End")}
      </p>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                classes={{ input: classes.input }}
              >
                <KeyboardDatePicker
                  disableToolbar
                  //variant="inline"
                  format="MM/dd/yyyy"
                  // margin="normal"
                  id="date-picker-inline"
                  //disablePast={true}
                  value={value.end}
                  disableFuture
                   maxDate={endDate}
                  onChange={(e) =>
                    handleSideBarChange({ target: { name: "end", value: e } })
                  }
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  InputProps={{
                    disableUnderline: true,
                   }}
                  keyboardIcon={<Icon style={{color:'#0b79b6',fontSize:25,alignSelf: "center",height:35}}>date_range</Icon>}
                  fullWidth
                  className={classes.textField}
                />
              </MuiPickersUtilsProvider>
            </div>
          </div>
          </Grid>
          
          <Grid item xs={12}  md={8} sm={12} style={{alignSelf:'center',marginBottom:10}}>
          <div style={{flexDirection:'row',display:'flex',justifyContent:'space-between'}}>
            <div className={classes.typography} style={{color:'#19123e'}}>
            <p className="filterHeading" style={{ color: "#306086", justifyContent: (language == "ar" ? "right" :"left"), display: "flex", fontSize: 14, fontWeight:'bold',marginTop:0,marginBottom:0 }}>
        {t("From (Previous)")}
      </p>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                classes={{ input: classes.input }}
              >
                <KeyboardDatePicker
                  disableToolbar
                  //variant="inline"
                  format="MM/dd/yyyy"
                  // margin="normal"
                  id="date-picker-inline"
                  className={classes.textField}
                  value={value.previous_from}
                  disableFuture minDate={startDatePrev}
                  onChange={(e) =>
                    handleSideBarChange({
                      target: { name: "previous_from", value: e },
                    })
                  }
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  InputProps={{
                    disableUnderline: true,
                   }}
                  keyboardIcon={<Icon style={{color:'#0b79b6',fontSize:25,alignSelf: "center",height:35}}>date_range</Icon>}
                  fullWidth
                />
              </MuiPickersUtilsProvider>
            </div>
            <div className={classes.typography} style={{color:'#19123e'}}>
            <p className="filterHeading" style={{ color: "#306086", justifyContent: (language == "ar" ? "right" :"left"), display: "flex", fontSize: 14, fontWeight:'bold',marginTop:0,marginBottom:0 }}>
        {t("End (Previous)")}
      </p>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                classes={{ input: classes.input }}
              >
                <KeyboardDatePicker
                  disableToolbar
                  //variant="inline"
                  format="MM/dd/yyyy"
                  // margin="normal"
                  id="date-picker-inline"
                  className={classes.textField}
                  value={value.previous_end}
                  disableFuture maxDate={endDatePrev}
                  onChange={(e) =>
                    handleSideBarChange({
                      target: { name: "previous_end", value: e },
                    })
                  }
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  InputProps={{
                    disableUnderline: true,
                   }}
                  keyboardIcon={<Icon style={{color:'#0b79b6',fontSize:25,alignSelf: "center",height:35}}>date_range</Icon>}
                  fullWidth
                />
              </MuiPickersUtilsProvider>
            </div>
           </div>
          </Grid>

          <Grid container item xs={12} md={8} sm={12} style={{alignSelf:'center',marginTop:'5px', marginBottom:'10px'}} >
              {companies &&<><p className="filterHeading" style={{ color: "#306086", justifyContent: "left", display: "flex", fontSize: 14, fontWeight:'bold',marginTop:0,marginBottom:0 }}>
        {t("Company")}
      </p> <FormControl  style={{width:'100%'}} variant="outlined" className="companySelectorF">
                <Select  style={{width:'100%',backgroundColor:'white'}} labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" onChange={(e) => handleSideBarChange({
                      target: { name: "company_id", value: e.target.value },
                    })} size="small" fullWidth className={"companySelectorFilter"} defaultValue={value.company_id}>
                  {companies.map((item, index) => {
                    return <MenuItem value={item.id}>
                        {item.company_name}
                      </MenuItem>;
                  })}
                </Select>
              </FormControl></>}          
          </Grid> 
          
           <Grid container item xs={12}  md={8} sm={12} style={{alignSelf:'center',marginTop:'5px', marginBottom:'10px'}} >
           <p className="filterHeading" style={{ color: "#306086", justifyContent: "left", display: "flex", fontSize: 14, fontWeight:'bold',marginTop:0,marginBottom:0 }}>
        {t("Template")}
      </p>
              <Autocomplete
                id="templated-design"
                style={{ display: "inline-block",width:"100%",backgroundColor:'white' }}
                //freeSolo
                options={templates}
                getOptionLabel={(option) => option.title}
                renderOption={(option) => (
                  <React.Fragment>{option.title}</React.Fragment>
                )}
                onChange={(e, value) =>
                  handleSideBarChange({
                    target: { name: "template_id", value: value },
                  })
                }
                value={value.template_id}
                renderInput={(params) => <TextField {...params} variant="outlined"/>}
                fullWidth
              />
          </Grid>

          <Grid container item xs={12}  md={8} sm={12} style={{alignSelf:'center',marginTop:'5px', marginBottom:'10px'}} >
          <p className="filterHeading" style={{ color: "#306086", justifyContent: "left", display: "flex", fontSize: 14, fontWeight:'bold',marginTop:0,marginBottom:0 }}>
        {t("Inspection")}
      </p>
              <Autocomplete
                id="inspection-design"
                style={{ display: "inline-block",width:"100%",backgroundColor:'white' }}
                //freeSolo
                options={inspections.filter((v) =>
                  value.template_id?.id
                    ? v.template_id === value.template_id?.id
                    : true
                )}
                getOptionLabel={(option) => option.title}
                renderOption={(option) => (
                  <React.Fragment>{option.title}</React.Fragment>
                )}
                renderInput={(params) => <TextField {...params} variant="outlined"/>}
                value={value.schedule_id}
                onChange={(e, value) =>
                  handleSideBarChange({
                    target: { name: "schedule_id", value: value },
                  })
                }
                fullWidth
              />
          </Grid>
          <Grid container item xs={12}  md={8} sm={12} style={{alignSelf:'center', marginTop:'5px', marginBottom:'10px'}} >
          <p className="filterHeading" style={{ color: "#306086", justifyContent: "left", display: "flex", fontSize: 14, fontWeight:'bold',marginTop:0,marginBottom:0 }}>
        {t("Site")}
      </p>
              <Autocomplete
                id="site-design"
                style={{ display: "inline-block",width:"100%",backgroundColor:'white' }}
                //freeSolo
                options={sites}
                getOptionLabel={(option) => option.title}
                renderOption={(option) => (
                  <React.Fragment>{option.title}</React.Fragment>
                )}
                onChange={(e, value) =>
                  handleSideBarChange({
                    target: { name: "site_id", value: value },
                  })
                }
                value={value.site_id}
                renderInput={(params) => <TextField {...params} variant="outlined"/>}
                fullWidth
              />

          </Grid>
        </Grid>
        <Grid item xs={12}  md={12} sm={12} align="center" style={{marginTop:10,alignSelf:'center'}}>
          <Button
            variant="contained"
            className="addBtn"
            color="primary"
            style={{
              backgroundColor: "#043077",
              // borderRadius: 12,
              // width: 80,
              marginBottom: 10,
              width:200
            }}
            onClick={() => {
              
              if (btnLoader === false) {
                setBtnLoader(true);
                handleSideBarSubmitProgress(null);
                handleSideBarSubmitProgressPrevious();
              }
            }}
          >
            {btnLoader === true && (
              <CircularProgress
                size={18}
                style={{ color: "white", marginRight: 7 }}
              />
            )}
            {t("Apply")}
          </Button>
        </Grid>
      </Grid>
      {/* </Grid> */}
    </div>
  );
};
